import { BaseWebComponentView } from '../../../framework/BaseWebComponentView';
import { GzTitleWebComponent } from '../../../ui/gzTitle';
import { LicenseConstants } from '../../LicenseConstants';
import { FormGroup } from '../../../ui/gzForm/formGroup/form-group';
import { GzLinkWebComponent } from '../../../ui/gzLinkComponent';
import { htmlEncode } from '../../../utils/escape.utils';

interface FratProductInformation {
  $infoText: HTMLElement;
  $link: GzLinkWebComponent;
}

export class LicenseFratSubFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $productDetailsTitle: GzTitleWebComponent;

    productInformation: FratProductInformation;
  };

  public formGroup: FormGroup = new FormGroup({});

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('#wrapper'),
      $productDetailsTitle: this.shadow.querySelector('#frat-product-details-title'),

      productInformation: {
        $infoText: this.shadow.querySelector('#frat-product-details-text'),
        $link: this.shadow.querySelector('#frat-product-details-link'),
      },
    };

    this.setTranslatedStrings();
  }

  setTranslatedStrings() {
    this.dom.$productDetailsTitle.innerText = this.dependencies.translateFn('Product Details');

    this.dom.productInformation.$infoText.innerText = this.dependencies.translateFn(
      'Free Risk Assessment Tool is a lightweight solution that uses Bitdefender`s Endpoint Risk Analytics technology to identify security vulnerabilities on the endpoints, and recommends solutions to harden the security of the computer network.'
    );
    this.dom.productInformation.$link.innerHTML = `<span>${htmlEncode(
      this.dependencies.translateFn('Learn more')
    )}</span>`;
    this.dom.productInformation.$link.href = LicenseConstants.InfoLinks.FRAT;
  }

  buildSuccessView(data: any) {}

  buildErrorView(error: Error) {}
}
